<script setup>
import PortalAuthShell from '@/Layouts/PortalAuthShell.vue'
</script>

<template>
  <PortalAuthShell portal="vendor">
    <slot />
  </PortalAuthShell>
</template>
